import { useQuery } from '@apollo/client'
import { Box, Stack } from '@mui/material'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { GetCompanyClients } from 'recruiter/graphql/companies.gql'
import { recruiterRouteConfig } from 'recruiter/routes'
import useToast from 'shared/components/Toast/useToast'
import { usePageTitle } from 'shared/hooks/usePageTitle'
import { getPxAsRem } from 'shared/utils'
import AddClientModal from './AddClient'
import PermissionsHeader from './Header'
import PermissionsUsers from './UsersContainer'

interface ClientPermissionsProps {}

const ClientPermissions: React.FC<ClientPermissionsProps> = () => {
    const companyId = useParams<{ companyId: string }>().companyId
    const toast = useToast()
    const navigate = useNavigate()
    const [modalOpen, setModalOpen] = React.useState(false)

    const { data, refetch } = useQuery(GetCompanyClients, {
        variables: { companyId: companyId ?? '' },
        onError: (error) => {
            toast({
                title: 'Error',
                severity: 'error',
                message: error.message,
            })
            navigate(`${recruiterRouteConfig.companies.path}/${companyId}`)
        },
    })

    usePageTitle(
        data?.company?.value
            ? `${data.company.value} · Client Permissions`
            : undefined
    )

    return (
        <>
            <Stack direction="column" spacing={2}>
                <PermissionsHeader data={data} />
                <Box sx={{ padding: getPxAsRem(16, 24) }}>
                    <PermissionsUsers
                        data={data}
                        refetch={refetch}
                        onAddUser={() => setModalOpen(true)}
                    />
                </Box>
            </Stack>
            <AddClientModal
                open={modalOpen}
                onCancel={() => setModalOpen(false)}
                refetch={refetch}
                companyId={companyId ?? ''}
            />
        </>
    )
}

export default ClientPermissions
